export const ROLE             = 'role';
export const ARIA_CONTROLS    = 'aria-controls';
export const ARIA_CURRENT     = 'aria-current';
export const ARIA_LABEL       = 'aria-label';
export const ARIA_HIDDEN      = 'aria-hidden';
export const TAB_INDEX        = 'tabindex';
export const DISABLED         = 'disabled';
export const ARIA_ORIENTATION = 'aria-orientation';

/**
 * The array with all attributes.
 *
 * @since 3.0.0
 */
export const ALL_ATTRIBUTES = [
  ROLE,
  ARIA_CONTROLS,
  ARIA_CURRENT,
  ARIA_LABEL,
  ARIA_HIDDEN,
  ARIA_ORIENTATION,
  TAB_INDEX,
  DISABLED,
];
